















import { Vue, Component } from "vue-property-decorator";
@Component
export default class ContentRibbon extends Vue {
  public get hasMenu() {
    return this.$route.matched.find(route => {
      return this.$_.has(route.components, "menu");
    });
  }
}
